import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'
import { useAuthDataContext } from '../../../../__providers/AuthProvider'
import Api from '../../../../__helpers/api'

//images
import mainImage from '../../../../assets/images/modals/messages/activation-expires/icons/main.png'
import closeIcon from '../../../../assets/images/modals/messages/feedback/icons/close.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

function ActivationExpires(props, ref) {
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.ACTIVATION_EXPIRES?.data || {}

    const [state, setState] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        setState(state => ({
            ...state,
            blur: true,
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 0)
    }

    const handleClose = () => {
        dispatch(handleModal('ACTIVATION_EXPIRES', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        Api.post('notifications/mark-as-read', {
            id: data?.id
        })
            .then(() => {
                dispatch(refreshNotification())
            })

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }


    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>

            <div className={`box activation-expires-modal ${state.popup ? 'show' : ''}`}>
                <img src={closeIcon} className="close" onClick={handleClose} />
                <img src={mainImage} className="main" />
                <h2>
                    Остават {data?.daysleft} дни 
                    <br />
                    за твоето Авто Обучение
                </h2>
                <p>
                    {data?.name}, остава ти още малко време, в което можеш да гледаш видео лекции и да решаваш изпитни въпроси в Авто Обучение. Ако имаш нужда от още време, може да се свържеш с нас.
                </p>

                <Button onClick={handleClose} className="primary">
                    Разбрах
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(ActivationExpires)